module.exports = __webpack_public_path__ + "img/icon_ubicationtechassitance_management.7111326f.svg";